<template>
  <div :class="$b({ checked: modelValue })">
    <BaseCopy
      v-if="$slots.label"
      size="body-sm"
      :text-transform="textTransform"
      class="BaseToggle__label"
    >
      <slot name="label" />
    </BaseCopy>

    <span
      v-if="offLabel"
      class="BaseToggle__off-label"
      @click="handleInput(false)"
    >
      {{ $tr(offLabel) }}
    </span>

    <span
      v-if="$slots['off-icon']"
      class="BaseToggle__off-icon"
      @click="handleInput(false)"
    >
      <slot name="off-icon" />
    </span>

    <label class="BaseToggle__switch">
      <input
        class="BaseToggle__input"
        type="checkbox"
        :value="modelValue"
        @change="handleInput($event.target.checked)"
      />
      <div class="BaseToggle__indicator" />
    </label>

    <span
      v-if="$slots['on-icon']"
      class="BaseToggle__on-icon"
      @click="handleInput(true)"
    >
      <slot name="on-icon" />
    </span>

    <span
      v-if="onLabel"
      class="BaseToggle__on-label"
      @click="handleInput(true)"
    >
      {{ $tr(onLabel) }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'BaseToggle',
  props: {
    modelValue: { type: Boolean, required: true },
    onLabel: { type: String, default: '' },
    offLabel: { type: String, default: '' },
    textTransform: {
      type: String,
      default: 'uppercase',
      validator: (value) => {
        return ['capitalize', 'uppercase', 'lowercase'].includes(value)
      },
    },
  },
  emits: ['input', 'update:modelValue'],
  methods: {
    handleInput(value) {
      this.$emit('update:modelValue', value)
      this.$emit('input', value)
    },
  }
}
</script>

<style lang="postcss">
.BaseToggle {
  display: flex;
  align-items: center;
  justify-content: center;

  .BaseToggle__switch {
    position: relative;
    display: inline-block;
    height: 20px;
    width: 40px;
    min-width: 40px;
    background: theme('colors.grey.DEFAULT');
    border-radius: 20px;
    appearance: none;
  }

  .BaseToggle__input {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    width: 40px;
    height: 20px;
    cursor: pointer;
  }

  .BaseToggle__indicator {
    height: 14px;
    width: 14px;
    margin: 3px;
    border-radius: 50%;
    transition: transform 0.3s ease;
    background: theme('colors.white');
  }

  &--checked {
    .BaseToggle__switch {
      background-image: var(--gradient-default);
    }

    .BaseToggle__indicator {
      transform: translateX(20px);
    }

    .BaseToggle__on-icon,
    .BaseToggle__on-label {
      opacity: 0.8;
    }

    .BaseToggle__off-icon,
    .BaseToggle__off-label {
      opacity: 0.4;
    }
  }
}

.BaseToggle__on-icon {
  opacity: 0.4;
  padding-left: 4px;
}

.BaseToggle__off-icon {
  opacity: 0.8;
  padding-right: 4px;
}

.BaseToggle__on-label {
  opacity: 0.4;
  padding-left: 8px;
  transform: translateY(2px);
}

.BaseToggle__off-label {
  opacity: 0.8;
  padding-right: 8px;
  transform: translateY(2px);
}

.BaseToggle__label {
  font-size: 12px;
  padding-right: 8px;

  .sgi {
    padding-right: 4px;
  }
}
</style>
